import React from 'react'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from 'ag-grid-react'

export const RecordInsertCategoryWise = (props) => {
    return (
        <div className='record-insert'>
            <span className="text-blue text-[16px] font-semibold ">Select item category</span>
            <div className='item-grp grid grid-cols-3 gap-2.5 mt-[5px]'>
                <div className='input-grp'>
                    <label>Select type</label>
                    <MultiSelectDropdown
                        drpIdentity="Select type"
                        options={props.plantObject.types}
                        value={props.plantObject.itemTypeId ? props.plantObject.types.find(x => x.value === props.plantObject.itemTypeId) : 0}
                        onChange={(event) =>
                            props.handleChangeFroDropdown(event, "itemTypeId")
                        }
                        className={props.validState?.error?.itemTypeId !== undefined ? "error" : ""}
                    />
                </div>
                {/* <div className='input-grp'>
                    <label>Select category</label>
                    <MultiSelectDropdown
                        drpIdentity="Select category"
                        options={props.plantObject.categoryList}
                        value={props.plantObject.categoryId ? props.plantObject.categoryList.find(x => x.value === props.plantObject.categoryId) : 0}
                        onChange={(event) =>
                            props.handleChangeFroDropdown(event, "categoryId")
                        }
                        className={props.validState?.error?.categoryId !== undefined ? "error" : ""}
                    />
                </div> */}
                <div className='input-grp'>
                    <label>Select plant</label>
                    <MultiSelectDropdown
                        drpIdentity="Select plant"
                        options={props.plantObject.plantList}
                        value={props.plantObject.idPlant ? props.plantObject.plantList.find(x => x.value === props.plantObject.idPlant) : 0}
                        onChange={(event) =>
                            props.handleChangeFroDropdown(event, "idPlant")
                        }
                        className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                    />
                </div>
                <div className='input-grp flex items-center gap-2.5'>
                    <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.viewRecords()}>View records</button>
                    {props.plantObject.rowData.length > 0 ?
                        <button className="update-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.saveRecords()}>Save</button>
                        :
                        null
                    }
                </div>
                {/* <div className='input-grp'>
                    <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.saveRecords()}>Save</button>
                </div> */}
            </div>
            <div className='record-table mt-5' style={{ height: "calc(100vh - 279px)" }}>
                <div className="table-inner h-full">
                    <AgGridReact
                        rowData={props.plantObject.rowData}
                        columnDefs={props.plantObject.colDefs}
                        onCellClicked={props.handleCellClickItemList}
                    />
                </div>
            </div>
        </div>
    )
}
